import React from "react"
import Skeleton from "@components/Skeleton/Skeleton"
import { LabsListingShort as LabsListingConfig } from "@widgets/LabsListing/LabsListing.skeleton"
import { FiltersConfig } from "./Filters/Filters.skeleton"
import { TestSuggestionsConfig } from "./TestSuggestions/TestSuggestions.skeleton"
import { PopularTestsConfig } from "./PopularTests/PopularTests.skeleton"
import { HeadingWithDropdownConfig } from "@widgets/HeadingWithDropdown/HeadingWithDropdown.skleton"
import css from "./InventoryPage.scss"

function InventoryPageSkeleton() {
    return (
        <div className="page-container">
            <div className={`flex container-fluid padding-40-0 ${css.pageHeight}`}>
                <div className="flexColumn">
                    <Skeleton config={FiltersConfig} isComponent={true} />
                </div>

                <div className={`col-2 flex justifyCenter`} />

                <div className="flexColumn">
                    <Skeleton config={HeadingWithDropdownConfig} isComponent={true} />
                    <Skeleton config={LabsListingConfig} isComponent={true} />
                </div>

                <div className={`col-2 flex justifyCenter`} />

                <div className="flexColumn">
                    <Skeleton config={TestSuggestionsConfig} isComponent={true} />
                    <Skeleton config={PopularTestsConfig} isComponent={true} />
                </div>
            </div>
        </div>
    )
}

export default InventoryPageSkeleton
